const createPingdomRum = () => {
  if (!window.location.href.includes('pingdomrumtest')) {
    return;
  }

  const scriptTag = window.document.createElement('script');

  // eslint-disable-next-line unicorn/prevent-abbreviations
  scriptTag.src = '//rum-static.pingdom.net/pa-5f733b0635289b0013000003.js';
  scriptTag.async = true;

  window.document.body.append(scriptTag);
};

export default createPingdomRum;
